<template>
  <a
    v-if="showSeal"
    href="https://www.ekomi.de/bewertungen-zaun24.de.html"
    target="_blank"
    class="badge badge-ekomi"
    aria-label="Ekomi Bewertungen"
  >
    <img
      v-if="sealImg"
      v-lazy="sealImg"
      alt="Ekomi"
    >
  </a>
</template>

<script>
export default {
  name: 'EkomiSeal',
  data () {
    return {
      sealImg: null,
      showSeal: false
    }
  },
  async mounted () {
    // Watch changes of dataLayer.eKomi
    this.observeDataLayer()

    if (this.isEkomiEnabled()) {
      await this.loadSeal()
    }
  },
  methods: {
    isEkomiEnabled () {
      return window.dataLayer?.find?.(e => e.eKomi !== undefined)?.eKomi === true
    },
    observeDataLayer () {
      // Polling approach (simpler, robust)
      this.checkInterval = setInterval(async () => {
        const enabled = this.isEkomiEnabled()
        if (enabled !== this.showSeal) {
          this.showSeal = enabled
          if (enabled && !this.sealImg) {
            await this.loadSeal()
          }
        }
      }, 1000)
    },
    async loadSeal () {
      const timeout = 60 * 60 * 1000 // one hour

      try {
        const seal = JSON.parse(localStorage.getItem('ekomiSeal'))
        if (seal.time > (new Date()).getTime() - timeout) {
          this.sealImg = seal.img
          return
        }
      } catch (e) {}

      this.sealImg = await this.getSealImg()
      localStorage.setItem('ekomiSeal', JSON.stringify({
        img: this.sealImg,
        time: (new Date()).getTime()
      }))
    },
    async getSealImg () {
      const rating = await this.fetchRating()
      return 'https://sw-assets.ekomiapps.de/resources/de_seal_' + this.getSealForReview(rating) + '-500.png'
    },
    async fetchRating () {
      const summary = this.$store.state.ekomi && this.$store.state.ekomi.summary
      if (summary && summary.rating) return Number(summary.rating)
      await this.$store.dispatch('ekomi/load')
      const loaded = this.$store.state.ekomi && this.$store.state.ekomi.summary
      return loaded ? Number(loaded.rating) : 0
    },
    ratingRange (e, t, a) {
      return e >= t && e < a
    },
    getSealForReview (e) {
      let seal = 'standard';
      if (this.ratingRange(e, 4.8, 5.1)) {
        seal = 'gold'
      }
      if (this.ratingRange(e, 4.45, 4.8)) {
        seal = 'silver'
      }
      if (this.ratingRange(e, 4, 4.45)) {
        seal = 'bronze'
      }
      return seal
    }
  },
  beforeDestroy () {
    clearInterval(this.checkInterval)
  }
}
</script>
